export default function populatePayoutCheckingForm(formData, data = {}) {
  const result = {
    ...formData,
  };

  const details = data.details || {};

  if (details.type) {
    result.type = details.type;
  }

  if (details.accountType) {
    result.accountType = details.accountType;
  }

  if (details.lastFour) {
    result.accountNumber = details.lastFour;
  }

  if (details.routingNumber) {
    result.routingNumber = details.routingNumber;
  }

  if (details.firstName) {
    result.firstName = details.firstName;
  }

  if (details.lastName) {
    result.lastName = details.lastName;
  }

  result.valid = false;

  result.paymentOption = data;

  return result;
}
